<template>
    <div class="wrap">
        <div class="top-title">您的当前位置：首页 &lt; 期刊</div>
        <!--内容-->
        <div class="content flex-row">
            <div class="contentLeft">
                <div class="box" v-for="(val, index) in arrOne" :key="index">
                    <div @click="goQkDetail(val)" class="boxImg">
                        <img :src="val.coverImg" />
                    </div>
                    <div class="boxOne">{{ val.title }}</div>
                    <div class="boxTwo">作者：{{ val.author }}</div>
                    <div class="boxThree">
                        {{ val.createTime.time | dateFormat }}
                    </div>
                </div>
            </div>
            <div class="contentRight">
                <div class="contentRightTitle">最新期刊</div>
                <div
                    v-for="(item, index) in newQkData"
                    :key="index"
                    class="item-box clearfix flex-row"
                >
                    <div @click="goQkDetail(item)" class="imgRightBox">
                        <img :src="item.coverImg" :alt="item.title" />
                    </div>
                    <div class="rightBoxs">
                        <div class="new-title">
                            {{
                                item.title.length > 30
                                    ? item.title.substring(0, 30) + "..."
                                    : item.title
                            }}
                        </div>
                        <p class="qk-time">
                            {{ item.createTime.time | dateFormat }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <pagebreak :totalPage="totalPage" @changePage="changePage"></pagebreak>
    </div>
</template>
<script>
export default {
    name: "qk",
    data() {
        return {
            arrOne: [],
            newQkData: [],
            ajaxCancel: null,
            totalPage: 1
        };
    },
    created() {
        //期刊
        this.getQkData();
        this.getNewQkData();
    },
    methods: {
        getQkData(page = 1) {
            this.ajaxCancel && this.ajaxCancel();
            this.$ajax(
                {
                    method: "post",
                    url: "homePage/getPeriodical",
                    data: {
                        current: page
                    },
                    success: res => {
                        if (res.code == 200) {
                            this.arrOne = res.message.records;
                            this.totalPage = Math.ceil(
                                res.message.total / res.message.size
                            );
                        }
                    },
                    error: res => {}
                },
                this.ajaxCancel
            );
        },
        getNewQkData() {
            this.$ajax({
                method: "post",
                url: "homePage/getPeriodical",
                data: {
                    curren: 1
                },
                success: res => {
                    if (res.code == 200) {
                        res.message.records.length > 5
                            ? (res.message.records.length = 5)
                            : "";
                        this.newQkData = res.message.records;
                    }
                },
                error: res => {}
            });
        },
        changePage(index) {
            this.getQkData(index);
        },
        goQkDetail(item) {
            this.$router.push({
                name: "qkdetail",
                query: {
                    id: item.id,
                    title: item.title
                }
            });
        }
    }
};
</script>

<style scoped="scoped" lang="scss">
.wrap {
    width: 1000px;
    margin: 0 auto;
}

.top-title {
    font-size: 16px;
    color: #999;
}

.content {
    width: 1000px;
    min-height: 500px;
    overflow: hidden;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-between;
}

.contentLeft {
    display: inline-block;
    width: 680px;
}

.contentRight {
    display: inline-block;
    width: 280px;
}
.box {
    width: 157px;
    margin-right: 15px;
    margin-top: 10px;
    display: inline-block;
    vertical-align: middle;
}
.box:nth-child(4n) {
    margin-right: 0;
}

.boxImg {
    width: 157px;
    height: 214px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    transition: all ease 0.2s;
    cursor: pointer;
}
.boxImg:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.boxImg img {
    width: 100%;
    height: 100%;
    border: 0;
}
.boxOne {
    font-size: 16px;
    height: 20px;
    margin-top: 10px;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.boxTwo,
.boxThree {
    font-size: 14px;
    color: gray;
}
.contentRightTitle {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
}
.item-box {
    align-items: flex-start;
    margin-bottom: 10px;
    .imgRightBox {
        width: 108px;
        height: 148px;
        display: inline-block;
        border: 1px solid #ddd;
        transition: all ease 0.3s;
        cursor: pointer;
        overflow: hidden;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .imgRightBox:hover {
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }
    .rightBoxs {
        display: inline-block;
        padding-left: 10px;
        flex: 1;
        .new-title {
            font-size: 16px;
            max-height: 100px;
            line-height: 20px;
            color: #000;
            margin-bottom: 10px;
        }
        .qk-time {
            line-height: 28px;
            height: 28px;
            overflow: hidden;
            color: #666;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shouye/qk.vue